import classNames from "classnames";
import * as React from "react";

import style from "./status-badge.scss";
import layoutStyle from "styles/layout.scss";
import statusStyle from "styles/status.scss";

export enum Status {
    ERROR,
    SUCCESS,
    WARNING,
    NEUTRAL,
    INFO,
}

interface Content {
    status: Status;
    title: string;
}

const STATUS_TO_CLASSNAME = new Map([
    [Status.ERROR, statusStyle.statusFailed],
    [Status.SUCCESS, statusStyle.statusSuccessful],
    [Status.WARNING, statusStyle.statusWarning],
    [Status.NEUTRAL, statusStyle.statusNeutral],
    [Status.INFO, statusStyle.statusInfo],
]);

const IS_EXPIRED = new Map([[true, statusStyle.statusFailed]]);

function toClassname(status: Status, expired: boolean): string {
    const className = expired ? IS_EXPIRED.get(expired) : STATUS_TO_CLASSNAME.get(status);
    return className != null ? className : statusStyle.statusWarning;
}

const StatusBadge = (props: {
    values: Content[];
    tooltip?: boolean;
    disabled?: boolean;
    testId?: string;
    dataType?: string;
    icon?: React.ReactNode;
    expired?: boolean;
}): JSX.Element => (
    <div>
        {props.values.map((value, index) => (
            <div
                data-testid={props.testId}
                data-type={props.dataType}
                className={classNames(
                    style.statusBadge,
                    toClassname(value.status, props.expired ? props.expired : false),
                    {
                        [layoutStyle.disabledContainer]: props.disabled,
                    }
                )}
                key={index}
            >
                {props.icon}
                {value.title}
            </div>
        ))}
    </div>
);

export default StatusBadge;
